<template>
  <div>
    <div class="admin">
      <div class="fluid-container">
        <div class="row no-gutters">
          <!-- menu admin -->
          <div class="col-3 menu-admin-wrap">
            <menu-admin></menu-admin>
          </div>
          <!-- menu admin -->

          <!-- main -->
          <div class="col-9 main full-mb">
            <div class="row"></div>
            <div class="row">
              <div class="col-12 mb-2">
                <div class="title-admin">
                  <h1 class="display-3 font-weight-black">
                    Ventas sobre pedido
                  </h1>
                </div>
              </div>
            </div>

            <!-- filtrar bar -->
            <div class="row mt-4 filtrar-admin">
              <div class="col-3">
                <v-dialog
                  ref="dialog"
                  v-model="modal"
                  :return-value.sync="desde"
                  persistent
                  full-width
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="desde"
                      label="Desde"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>

                  <v-date-picker v-model="desde">
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.dialog.save(desde)"
                      >OK</v-btn
                    >
                    <v-btn text color="primary" @click="modal = false"
                      >Cancelar</v-btn
                    >
                  </v-date-picker>
                </v-dialog>
              </div>

              <div class="col-4">
                <v-dialog
                  ref="dialog2"
                  v-model="modal2"
                  :return-value.sync="hasta"
                  persistent
                  full-width
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="hasta"
                      label="Hasta"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>

                  <v-date-picker v-model="hasta">
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.dialog2.save(hasta)"
                      >OK</v-btn
                    >
                    <v-btn text color="primary" @click="modal2 = false"
                      >Cancelar</v-btn
                    >
                  </v-date-picker>
                </v-dialog>
              </div>

              <div class="col-3 d-flex mt-4">
                <v-btn
                  @click="getVentasFiltradas()"
                  color="grey"
                  dark
                  class="mr-3"
                >
                  <v-icon class="mr-3">settings_overscan</v-icon>Filtrar
                </v-btn>
                <v-btn @click="resetFiltro()" outlined color="grey" dark>
                  <v-icon>settings_overscan</v-icon>Borrar filtro
                </v-btn>
              </div>
            </div>
            <!-- /filtrar bar -->

            <!-- tabla de ventas -->
            <div class="row mt-0 mb-5">
              <div class="col-12">
                <div>
                  <div
                    class="top d-flex align-items-center justify-content-between mb-3 column-direction"
                  >
                    <h5
                      class="font-weight-black"
                      v-if="showDesdeTitle && !showHastaTitle"
                    >
                      Todas las ventas de la fecha {{ desde }}
                      <br />
                      <h1 class="font-weight-black">
                        Total: ${{ total_ventas_dia }}
                      </h1>
                    </h5>
                    <h5
                      class="font-weight-black"
                      v-if="showDesdeTitle && showHastaTitle"
                    >
                      Todas las ventas desde la fecha {{ desde }} hasta
                      {{ hasta }}
                      <br />
                      <h1 class="font-weight-black">
                        Total: ${{ total_ventas_rango }}
                      </h1>
                    </h5>
                    <h2 class="font-weight-black" v-if="!showDesdeTitle">
                      Todas las ventas
                    </h2>
                  </div>

                  <!-- loader -->
                  <div v-if="loaderVentas" class="text-center loader-wrap-min">
                    <div
                      class="spinner-border text-primary"
                      style="width: 75px; height: 75px"
                      role="status"
                    >
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                  <!-- /loader -->

                  <div v-if="!loaderVentas">
                    <!-- datatable -->
                    <v-card v-if="ventas != ''">
                      <v-card-title>
                        <v-text-field
                          v-model="search"
                          append-icon="search"
                          label="Buscar"
                          single-line
                          hide-details
                          @keyup="setBuscadorVuex()"
                        ></v-text-field>
                      </v-card-title>
                      <v-data-table
                        :headers="headers"
                        :items="ventas"
                        :search="search"
                      >
                        <template v-slot:item.tipo_venta="{ item }">
                          <div
                            v-if="
                              item.tipo_venta == 'Stock' ||
                                item.tipo_venta == ''
                            "
                          >
                            <span class="badge badge-info" color="orange"
                              >Venta de stock</span
                            >
                          </div>
                          <div v-else>
                            <span class="badge badge-warning" color="purple"
                              >Venta especial / Sobre pedido</span
                            >
                          </div>
                        </template>

                        <template v-slot:item.estatus="{ item }">
                          <div v-if="item.estatus == 'pagada'">
                            <span class="badge badge-success">Pagada</span>
                          </div>
                          <div v-else>
                            <span class="badge badge-danger">Pago parcial</span>
                          </div>
                        </template>
                        <template v-slot:item.telefono="{ item }">
                          <div
                            v-if="item.telefono == '.' || item.telefono == ''"
                          >
                            No asignado
                          </div>
                          <div v-else>{{ item.telefono }}</div>
                        </template>
                        <template v-slot:item.acciones="{ item }">
                          <v-btn
                            class="mx-2"
                            text
                            dark
                            small
                            color="primary"
                            :to="'/admin/venta/' + item.id"
                          >
                            <v-icon dark>visibility</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-card>
                    <!-- /datatable -->

                    <!-- vacio -->
                    <div v-if="ventas == ''">
                      <div class="vacio">
                        <span>No hemos encontrado ventas</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /tabla de ventas -->
          </div>
          <!-- /main -->
        </div>
      </div>
    </div>
    <!-- /desktop -->
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
const axios = require("axios");
import { mapState, mapActions } from "vuex";
export default {
  components: {
    Datepicker,
  },
  data() {
    return {
      //Date picker vuetify
      modal: false,
      desde: "",

      modal2: false,
      hasta: "",

      cobrar: false,
      tipoCliente: "generico",
      loader: false,
      productos: "",
      buscar: "",
      total: "",
      precio_servicio: "",
      concepto_servicio: "",
      disablePagination: false,

      nombre_cliente: "",
      telefono_cliente: "",
      email_cliente: "",
      direccion_cliente: "",
      loaderVenta: false,

      buscar: "",
      buscarVentaInput: "",

      hoy: "",

      ventas: "",
      loaderVentas: false,

      total_ventas_dia: "",
      total_ventas_rango: "",

      items: [],

      showDesdeTitle: false,
      showHastaTitle: false,

      //Table
      search: "",
      headers: [
        {
          text: "#ID",
          align: "left",
          sortable: false,
          value: "id",
        },
        { text: "Tipo de venta", value: "tipo_venta" },
        { text: "Fecha", value: "fecha" },
        { text: "Monto", value: "monto" },
        { text: "Cliente", value: "cliente", class: "addSign" },
        { text: "Teléfono", value: "telefono" },
        { text: "Estatus", value: "estatus" },
        { text: "Acciones", value: "acciones" },
      ],
    };
  },
  methods: {
    resetFiltro() {
      this.getVentas();
      this.desde = "";
      this.hasta = "";
      this.search = "";
      this.showDesdeTitle = false;
      this.showHastaTitle = false;
    },
    customFormatter(date) {
      return moment(date).format("MMMM Do YYYY, h:mm:ss a");
    },
    getVentas() {
      this.loaderVentas = true;
      //Obtenemos los productos
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getVentasNoStock"
        )
        .then((response) => {
          console.log(response);
          this.ventas = response.data;
          this.loaderVentas = false;
        })
        .catch((error) => console.log(error));
    },
    getVentasFiltradas() {
      if (this.desde == "" && this.hasta == "") {
        //No seleccionó ningún campo
        this.$swal({
          type: "error",
          customClass: "arriba",
          title: "Selecciona la fecha deseada",
          showConfirmButton: true,
        });
      } else if (this.desde != "" && this.hasta == "") {
        //Necesita ventas por día
        this.loaderVentas = true;
        this.showDesdeTitle = true;

        //Traemos ventas del día
        axios
          .get(
            "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getVentasFiltradasPorDiaNoStock" +
              "&dia=" +
              this.desde
          )
          .then((response) => {
            console.log(response);
            this.ventas = response.data;
            this.loaderVentas = false;
          })
          .catch((error) => console.log(error));

        //Traemos el total del día
        axios
          .get(
            "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getTotalVentasDiaNoStock" +
              "&dia=" +
              this.desde
          )
          .then((response) => {
            this.total_ventas_dia = response.data.total;
          })
          .catch((error) => console.log(error));
      } else if (this.desde == "" && this.hasta != "") {
        //Solo seleccionó la fecha hasta
        this.$swal({
          type: "error",
          customClass: "arriba",
          title:
            "Selecciona la fecha 'Desde' para crear un reporte por rango de fecha",
          showConfirmButton: true,
        });
      } else if (this.desde !== "" && this.hasta !== "") {
        //Necesita fecha por rango
        this.loaderVentas = true;
        this.showDesdeTitle = true;
        this.showHastaTitle = true;

        //Traemos las ventas por rango de fecha

        axios
          .get(
            "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getVentasFiltradasPorRangoFechaNoStock" +
              "&desde=" +
              this.desde +
              "&hasta=" +
              this.hasta
          )
          .then((response) => {
            console.log(response);
            this.ventas = response.data;
            this.loaderVentas = false;
          })
          .catch((error) => console.log(error));

        //Traemos total del día
        axios
          .get(
            "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getTotalVentasRangoFechaNoStock" +
              "&desde=" +
              this.desde +
              "&hasta=" +
              this.hasta
          )
          .then((response) => {
            this.total_ventas_rango = response.data.total;
          })
          .catch((error) => console.log(error));
      }
    },

    getVentasPorFecha() {
      //Validamos
      if (
        this.desde_mes == "" ||
        this.desde_ano == "" ||
        this.hasta_mes == "" ||
        this.hasta_ano == ""
      ) {
        //Mostramos alerta de error
        this.$swal({
          type: "error",
          customClass: "arriba",
          title: "Llena todos los campos necesarios para filtrar por fecha",
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        let desde = this.desde_ano + "-" + this.desde_mes + "-" + "1";
        let hasta = this.hasta_ano + "-" + this.hasta_mes + "-" + "1";

        this.loaderVentas = true;
        //Obtenemos los productos
        axios
          .get(
            "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getVentasPorFecha&desde=" +
              desde +
              "&hasta=" +
              hasta
          )
          .then((response) => {
            console.log(response);
            this.ventas = response.data;
            this.loaderVentas = false;
          })
          .catch((error) => console.log(error));
      }
    },
  },

  mounted() {
    this.getVentas();
  },
};
</script>
